<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-title>
      <img
        [src]="logoSrc()"
        alt="okcargo"
        class="menu-logo"
      />
      <span class="app-name-tagline">{{ APP_NAME_TAGLINE | translate }}</span>
    </ion-title>
  </ion-toolbar>
</ion-header>
